import { QueryResult } from 'react-query';
import { callApi, Controller, getApiUrl, useApi, UseApiOptions } from './useApi';

export enum SmRefType {
    angebot = 'angebot',
    service = 'service',
    auftrag = 'auftrag',
    bestellung = 'bestellung',
    lieferung = 'lieferung',
    rechnung = 'rechnung',
    lieferantenrechnung = 'lieferantenrechnung',
}

export interface Attachment {
    kNr: number;
    datum: string;
    art: number;
    smRefType: SmRefType | null;
    smRef: string;
    text: string;
    file: string;
    anzeige: boolean;
    oneDriveUrl: string | null;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export interface AttachmentFilter {
    kNr?: number;
    maxRows?: number;
}

export function useAttachmentList(
    filter: AttachmentFilter,
    apiOptions?: UseApiOptions<Attachment[]>,
): QueryResult<Attachment[]> {
    return useApi<Attachment[]>(Controller.attachment + '/list', { filter }, apiOptions);
}

export async function uploadAttachment(file: File, attachment: Attachment): Promise<boolean> {
    const data = new FormData();
    data.append('file', file);
    data.append('attachment.kNr', attachment.kNr.toString());
    data.append('attachment.art', (attachment.art || 3).toString());
    data.append('attachment.text', attachment.text || '');
    data.append('attachment.smRefType', attachment.smRefType || '');
    data.append('attachment.smRef', attachment.smRef || '');
    data.append('attachment.datum', attachment.datum);
    data.append('attachment.anzeige', attachment.anzeige ? 'true' : 'false');

    const request: RequestInit = {
        method: 'post',
        mode: 'cors',
        credentials: 'include',
        headers: {},
        body: data,
    };

    const result = await fetch(getApiUrl(Controller.attachment + '/akte/upload'), request);
    return result.status === 200;
}

export async function updateAttachment(attachment: Attachment): Promise<void> {
    return callApi<void>(Controller.attachment + '/update', { attachment });
}

export async function deleteAttachment(attachment: Attachment): Promise<void> {
    return callApi<void>(Controller.attachment + '/delete', { attachment });
}
